<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container" (keydown)="keyDownFunction($event)">
    <div class="row">
        <div class="col-16">
            <h1 class="medium">Final Review and Confirmation</h1>
            <br />
        </div>
    </div>
    <button #focusableEleTop class="focusable-element" aria-describedby="ErrorBanner"></button>
    <div id="ErrorBanner" class="row" *ngIf="hasError" role="alert" aria-live="polite">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul role="list">
                    <li *ngFor="let error of ErrorMessages" role="listitem" aria-atomic="true">{{ error }}</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <p>
                <strong> Selected Plan : {{enrollment.PLANTYPENAME}}</strong>
                <br /><br />
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <h6>Please Read and Sign Below:</h6>
            <br />
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p>
                    <br />
                    <u>By completing this enrollment application, I agree to the following:</u>
                </p>
                <p>{{orgName}} is a Medicare Part D drug plan and has a contract with the Federal government. I
                    understand that this prescription drug coverage is in addition to my coverage under Medicare;
                    therefore, I will need to keep my Medicare coverage. It is my responsibility to inform {{orgName}}
                    of any prescription drug coverage that I have or may get in the future. I can only be in one
                    Medicare prescription drug plan at a time. If I am currently in a Medicare prescription drug plan,
                    my enrollment in {{orgName}} will end my enrollment in my current plan. Enrollment in this plan is
                    generally for the entire year. Once I enroll, I may leave this plan only at certain times of the
                    year and under certain special circumstances by sending a request to my former employer.</p>
                <p>
                    {{orgName}} serves a specific service area. If I move out of the area that {{orgName}} serves, I
                    need to notify the plan so I can disenroll and find a new plan in my new area. I understand that I
                    must use network pharmacies except in an emergency when I cannot reasonably use {{orgName}} network
                    pharmacies. Once I am a member of {{orgName}}, I have the right to appeal plan decisions about
                    payment or services if I disagree. I will read the Evidence of Coverage document from {{orgName}}
                    when I get it to know which rules I must follow to get coverage.
                </p>
                <p>I understand that if I leave this plan and do not have or obtain other Medicare prescription drug
                    coverage or credible coverage (as good as Medicare’s), I may have to pay a late enrollment penalty
                    in addition to my premium for Medicare prescription drug coverage in the future.</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <br /><br />
            <h6>Release of Information:</h6>
            <br /><br />
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p>
                    By joining this Medicare prescription drug plan, I acknowledge that {{orgName}} will release my
                    information to Medicare and other plans as is necessary for treatment, payment and health care
                    operations. I also acknowledge that the plan will release my information, including my prescription
                    drug event date, to Medicare, who may release it for research and other purposes that follow all
                    applicable Federal statutes and regulations. The information on this enrollment form is correct to
                    the best of my knowledge. I understand that if I intentionally provide false information on this
                    form, I will be disenrolled from the plan.
                </p>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-4">
            <div class="bottom-20">
                Signature: {{EnrolleeSign}}
            </div>
        </div>
        <div class="col-16">
            <div class="bottom-20">

                <label class="option">
                    <ValidatedCheckbox [id]="'beneficiary-has-signed-application'"
                        [label]="'Beneficiary has signed application'" [checked]="enrollment.APPSIGNEDIND"
                        (onValueChange)="enrollment.APPSIGNEDIND= $event">
                    </ValidatedCheckbox>
                </label>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p>Today's Date:{{CurrentDate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <ValidatedRadioButtonGroup
                    [label]="'If you are the authorized representative, you must sign above and provide the following information:'"
                    [options]="rblAuthorizedRep" [selectedValue]="enrollment.AUTHREPIND"
                    (onValueChange)="rblAuthorizedRepClick($event)" [radioGroupName]="'rblAuthorizedRep'">
                </ValidatedRadioButtonGroup>
            </div>
        </div>
    </div>
    <div *ngIf="isAuthRep">
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Name of authorized rep '" [text]="enrollment.AUTHREPNAME" [id]="'AUTHREPNAME'"
                        (onValueChange)="enrollment.AUTHREPNAME = $event" [validators]="[notBlankValidator]">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <!--<ValidatedTextField [label]="'Phone Number '"
                                        [text]="enrollment.AUTHREPPHONE"
                                        [maxlength]="10"
                                        (onValueChange)="enrollment.AUTHREPPHONE = $event"
                                        [validators]="[numericTextFieldValidator,lengthValidator]">
                    </ValidatedTextField>-->

                    <MaskedValidatedTextField class="field" [label]="'Phone Number of authorized rep'" [for]="'AUTHREPPHONE'"
                        [text]="enrollment.AUTHREPPHONE" (onValueChange)="enrollment.AUTHREPPHONE = $event"
                        [maxlength]="10" [inputMask]="phoneNumberInputMask">
                    </MaskedValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div class="input-wrapper wide">
                    <ValidatedDropDown [label]="'Relationship to Enrollee'" [for]="'AUTHREPREL'"
                        [text]="enrollment.AUTHREPREL" [disabled]="'false'"
                        [selectedValue]="enrollment.AUTHREPREL" (onValueChange)="enrollment.AUTHREPREL =$event"
                        [options]="rblRelation">
                    </ValidatedDropDown>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Address of authorized rep'" [text]="enrollment.AUTHREPADD1" [id]="'AUTHREPADD1'"
                        (onValueChange)="enrollment.AUTHREPADD1 = $event" [validators]="[notBlankValidator]">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'City'" [text]="enrollment.AUTHREPCITY" [id]="'AUTHREPCITY'"
                        (onValueChange)="enrollment.AUTHREPCITY = $event" [validators]="[notBlankValidator]">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-4">
                <div class="input-wrapper wide">
                    <ValidatedDropDown [selectedValue]="enrollment.AUTHREPST" [label]="'State'" [for]="'AUTHREPST'" [text]="'enrollment.AUTHREPST'" [disabled]="'false'"
                        (onValueChange)="enrollment.AUTHREPST  = $event" [options]="states" (blur)="onBlur()">
                    </ValidatedDropDown>
                </div>
            </div>
            <div class="col-4">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Zip'" [text]="enrollment.AUTHREPZIP" [id]="'AUTHREPZIP'"
                        (onValueChange)="enrollment.AUTHREPZIP = $event" [validators]="[notBlankValidator]"
                        [maxlength]="5">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="bottom-20">
                    <ValidatedTextField [label]="'Email of authorized rep (optional)'" [text]="enrollment.AUTHREPEMAIL" [id]="'AUTHREPEMAIL'"
                        (onValueChange)="enrollment.AUTHREPEMAIL = $event" [validators]="[]">
                    </ValidatedTextField>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-24">
                <div class="bottom-20">
                    <ValidatedCheckbox [id]="'cbxPOASignature'" [label]="'Power of Attorney has signed application'"
                        [checked]="enrollment.AUTHREPSIGNEDIND" (onValueChange)="enrollment.AUTHREPSIGNEDIND= $event">
                    </ValidatedCheckbox>
                </div>
            </div>
        </div>

    </div>
    <indvrep #helpToEnrollee [enrollmentindvrepViewModel]="enrollment"></indvrep>
    <div class="row">
        <div class="col-24">
            <div *ngIf="showTermsButton">
                <button class="button primary" (click)="formSubmit($event)">The Applicant has read and agrees to the Terms of
                    Enrollment</button>
            </div>
            <!--<button class="button primary" (click)="incompleteClick()" >Save Incomplete Enrollment</button>-->
            <button class="button cancel" (click)="goBack()">Go Back</button>
        </div>
    </div>
</div>